import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { makeGetRequest } from "../../services/httpHelper";
import SubscriptionFeatureCard from "../cards/SubscriptionFeatureCard";
import { Helmet } from "react-helmet-async";

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState(null);

  const getPlans = async () => {
    setIsLoading(true);
    const res = await makeGetRequest("subscription-plans");
    if (res && res.errorType) {
      // handle error if needed
    } else {
      const results = await res.data;
    
      /*const updatedPlans = results.map((plan) => {
        if (plan.plan === "Enterprise") {
          return {
            ...plan,
            monthly_fee: "Custom Pricing",
            max_member_count: "400+ members"
          };
        }
        return plan;
      });*/
      setPlans(results);
      setIsLoading(false);
      setServerError(null);
    }
  };

  useEffect(() => {
    getPlans();
  }, []);

  return (
    <>
      <Helmet>
        <title>CS Church Management & Accounting Software Plans</title>
        <meta
          name="description"
          content="Choose the right plan for your church based on your congregation size. CS Church Management provides affordable and scalable solutions with a 14-day free trial."
        />
        <link rel="canonical" href="/pricing" />
      </Helmet>

      <Wrapper id="pricing">
        <div className="whiteBg">
          <div className="container">
          
             <PricingHeader>
        <h2>CS Church Management Pricing</h2>
        <p>All plans include full features. Scale as your church grows.</p>
      </PricingHeader>

            <div className="row">
              {plans.length !== 0 ? (
                plans.map((plan) => (
                  <div className="col-md-3" key={plan.id}>
                    <SubscriptionFeatureCard
                      data={{ plan: plan, features: [] }}
                      showExcludedFeatures={false}
                    />
                  </div>
                ))
              ) : (
                <p className="text text-info">No Plans Found</p>
              )}
            </div>

            <AdditionalInfo>
              <p className="font13 text-center mt-5">
                * All plans support unlimited admin users. Additional members beyond your plan limit can be added at an affordable rate.
              </p>
              <h5 className="mt-4">Optional Features (One-time Setup Fees Apply)</h5>
              <ul style={{ textAlign: "left", maxWidth: "600px", margin: "0 auto" }}>
                <li>SMS Integration: Setup from 16,000 KES (up to 35,000 KES for multiple sender IDs)</li>
                <li>M-PESA Integration: Custom quote based on setup requirements</li>
                <li>SMS Credits: Purchased separately by the client</li>
              </ul>
            </AdditionalInfo>
          </div>
        </div>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;

const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const AdditionalInfo = styled.div`
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  font-size: 0.9rem;
  color: #666;
  text-align: center;
`;

const PricingHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 1.125rem;
    color: #6b7280;
  }
`;
